/** @format */

export type initLoginSessionDataType = {
  err_message: string;
  code: number;
};

export const initLoginSessionData: initLoginSessionDataType = {
  err_message: "",
  code: 0,
};
